import * as React from 'react';
import styled from 'styled-components';
import { Typography } from '../../style/Typography';
import Img from 'gatsby-image';

const PatchNoteWrapper = styled.div`
  background: ${props => props.theme.backgrounds.secondaryDark};
  padding: 20px;
  box-shadow: rgb(0 0 0 / 15%) 0px 4px 8px;
  border-radius: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
  height: 100%;

  &:hover {
    box-shadow: rgb(0 0 0 / 60%) 0px 4px 8px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 3px 0;
  }

  @media only screen and (max-width: ${props =>
      props.theme.breakpoints.small}) {
    width: 90vw;
    margin: 0 auto;
  }
`;

const StyledImg = styled(Img)`
  height: 240px;
`;

const PatchNote = ({ children, data }) => (
  <PatchNoteWrapper>
    <StyledImg fluid={data?.image?.fluid} />
    <Typography variant="captionSmall" color="brand">
      {data?.patchDate}
    </Typography>
    <Typography variant="h3">Version {data?.patchNumber}</Typography>
    <div
      dangerouslySetInnerHTML={{
        __html: data?.patchNotesSummary?.childMarkdownRemark?.html,
      }}
    />
    {children}
  </PatchNoteWrapper>
);

export const PatchNoteListItem = props => {
  return (
    <PatchNote {...props}>
      {/* <ReadMoreText variant="captionLarge" color="complimentaryPurple">
        Read more
      </ReadMoreText> */}
    </PatchNote>
  );
};
